module.exports = __webpack_public_path__ + "static/media/mode.1916a13c.svg";